<template>
  <div>
    <a
      class="nav-link dropdown-toggle pl-md-3 position-relative"
      href="#account"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <img
        v-if="$store.state.user.avatar"
        class="rounded-circle img-fluid"
        :src="$store.state.user.avatar"
        alt="user_avatar"
        style="width: 40px; height: 40px;"
      />
      <img
        v-else
        class="rounded-circle"
        alt="user_avatar"
        src="../../public/avatars/avatar-default.jpg"
        width="40"
      />

      <span class="ml-2 d-none d-lg-inline-block">
        <span class="text-dark">{{ this.$store.state.user.name }}</span>
        <i data-feather="chevron-down" class="svg-icon"></i
      ></span>
    </a>
    <div class="dropdown-menu dropdown-menu-right user-dd animated flipInY">
      <!--
        Other Options
      <a class="dropdown-item" href="javascript:void(0)"
        ><i data-feather="user" class="svg-icon mr-2 ml-1"></i> My Profile</a
      >
      <a class="dropdown-item" href="javascript:void(0)"
        ><i data-feather="credit-card" class="svg-icon mr-2 ml-1"></i> My
        Balance</a
      >
      
      <a class="dropdown-item" href="javascript:void(0)"
        ><i data-feather="mail" class="svg-icon mr-2 ml-1"></i> Inbox</a
      >
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="javascript:void(0)"
        ><i data-feather="settings" class="svg-icon mr-2 ml-1"></i> Account
        Setting</a
      >
      -->
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" @click="logout"
        ><i data-feather="power" class="svg-icon mr-2 ml-1"></i> Logout</a
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'AccountList',
  components: {},
  data() {
    return {
      itemsCount: 42,
    };
  },
  created() {},
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
  },
};
</script>
